<div class="login-page" data-bs-theme="dark">
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <h2 class="h3 mb-2">Two-Factor Authentication</h2>
      <p class="text-muted mb-0">
        Enter the {{ useBackupCode ? 'backup code' : '6-digit verification code' }} to complete your sign in
      </p>
    </div>

    <!-- Error Alert -->
    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage }}
    </div>

    <!-- 2FA Form -->
    <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
      <!-- Verification Code Input -->
      <div class="mb-4">
        <label for="code" class="form-label">
          {{ useBackupCode ? 'Backup Code' : 'Verification Code' }}
        </label>
        <input
          type="text"
          class="form-control form-control-lg text-center fs-4 fw-semibold font-monospace verification-input"
          id="code"
          formControlName="code"
          [placeholder]="useBackupCode ? '12345678' : '123456'"
          [maxlength]="useBackupCode ? 8 : 6"
          autocomplete="one-time-code"
          [class.is-invalid]="verifyForm.get('code')?.invalid && verifyForm.get('code')?.touched"
        />
        <div
          *ngIf="verifyForm.get('code')?.invalid && verifyForm.get('code')?.touched"
          class="invalid-feedback text-center"
        >
          Please enter a valid {{ useBackupCode ? '8-character backup code' : '6-digit verification code' }}
        </div>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="btn btn-primary btn-lg w-100 mb-3"
        [disabled]="loading || verifyForm.invalid"
      >
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        {{ loading ? 'Verifying...' : 'Verify Code' }}
      </button>

      <!-- Backup Code Toggle -->
      <div class="text-center mb-3">
        <button
          type="button"
          class="btn btn-link p-0 small text-decoration-none"
          (click)="toggleBackupCode()"
        >
          {{ useBackupCode ? 'Use verification code instead' : 'Use backup code instead' }}
        </button>
      </div>

      <!-- Back to Login -->
      <div class="text-center">
        <button
          type="button"
          class="btn btn-outline-secondary w-100"
          (click)="goBackToLogin()"
          [disabled]="loading"
        >
          <i class="bi bi-arrow-left me-2"></i>
          Back to Login
        </button>
      </div>
    </form>

    <!-- Help Text -->
    <div class="mt-4 p-3 bg-body-tertiary border rounded">
      <p class="mb-2 small">
        <i class="bi bi-info-circle me-2"></i>
        <strong>Need help?</strong>
      </p>
      <p class="mb-0 small text-muted">
        If you don't have access to your authenticator app or backup codes,
        please contact your system administrator for assistance.
      </p>
    </div>
  </div>
</div>
